import React from 'react';
import { cn } from '@/lib/utils';

// Feb 2026 iter 88: 4-chip filter. TYPSA is split between the two org-type
// buckets defined at the Opportunity level (is_typsa_collaboration).
// Non-opportunity modules still use one aggregate TYPSA bucket, so both
// chips filter the same set for them (see utils/clientType.js).
const CLIENT_TYPES = [
  { key: 'typsa_gg',    label: 'TYPSA',   title: 'TYPSA (GG / I+D+i)',                    activeColor: 'bg-red-600 text-white shadow-sm', dotColor: 'bg-red-600' },
  { key: 'typsa_colab', label: 'Colab.',  title: 'Colaboración TYPSA (proyectos en marcha)', activeColor: 'bg-sky-600 text-white shadow-sm',  dotColor: 'bg-sky-600' },
  { key: 'privada',     label: 'Privada', title: 'Privada',                                  activeColor: 'bg-purple-500 text-white shadow-sm', dotColor: 'bg-purple-500' },
  { key: 'publica',     label: 'Pública', title: 'Pública',                                  activeColor: 'bg-green-500 text-white shadow-sm',  dotColor: 'bg-green-500' },
];

/**
 * Reusable filter component for client types.
 * @param {string[]} selectedTypes - Array of selected keys.
 * @param {function} onToggle - Callback when a type is toggled.
 * @param {string} className - Additional CSS classes.
 */
const ClientTypeFilter = ({ selectedTypes, onToggle, className = '' }) => {
  const handleToggle = (type) => {
    if (selectedTypes.includes(type) && selectedTypes.length === 1) return;
    onToggle(type);
  };

  return (
    <div
      className={cn('flex items-center gap-1 p-1 rounded-lg border bg-muted/30', className)}
      data-testid="client-type-filter"
    >
      {CLIENT_TYPES.map(({ key, label, title, activeColor, dotColor }) => {
        const isSelected = selectedTypes.includes(key);
        return (
          <button
            key={key}
            onClick={() => handleToggle(key)}
            title={title}
            className={cn(
              'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all',
              isSelected ? activeColor : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            )}
            data-testid={key === 'typsa_gg' ? 'filter-typsa' : `filter-${key.replace('_', '-')}`}
          >
            <div className={cn('w-2 h-2 rounded-full', isSelected ? 'bg-white' : dotColor)} />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ClientTypeFilter;
